import { pageId } from "~/utils/pageId";

export default () => ({
    deployments: pageId({ area: "Project", id: "Project.Deployments", name: "Deployments", routeLink: null }),
    deployment: pageId({ area: "Project", id: "Project.Deployment", name: "Deployment", routeLink: null }),
});
